export default {
  All: 0,
  Summary: 1,
  ExpenseCash: 3371,
  ForeignDebt: 3372,
  TempFees: 3373,
  AdvanceEstimate: 3374,
  OrtherTempCollection: 3378,
};
